import { useQuery } from "react-query";
import { GetCalenderTicket } from "services/calender";

export default function UseGetCalenderTickets({start_date, end_date}:{start_date: string, end_date: string}) {

  return useQuery(
    ["calendar-tickets", start_date, end_date],
    () => GetCalenderTicket({start_date, end_date}),
    {
      keepPreviousData: true,
    }
  );
}
